/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReadOnlyUser,
    ReadOnlyUserFromJSON,
    ReadOnlyUserFromJSONTyped,
    ReadOnlyUserToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse20046
 */
export interface InlineResponse20046 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20046
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20046
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20046
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<ReadOnlyUser>}
     * @memberof InlineResponse20046
     */
    results: Array<ReadOnlyUser>;
}

export function InlineResponse20046FromJSON(json: any): InlineResponse20046 {
    return InlineResponse20046FromJSONTyped(json, false);
}

export function InlineResponse20046FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20046 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(ReadOnlyUserFromJSON)),
    };
}

export function InlineResponse20046ToJSON(value?: InlineResponse20046 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': ((value.results as Array<any>).map(ReadOnlyUserToJSON)),
    };
}


